import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Craft",
    quote: "A hinge that squeaks is a promise we haven't kept.",
    body:
      "Every job — from a five-minute fix to a five-month renovation — gets the same crew standard. The details are the work.",
  },
  {
    n: "02",
    title: "Trust",
    quote: "Your keys, your home, your investment. Handled like family.",
    body:
      "Fully licensed, insured, and bonded in Pennsylvania. Written estimates. No surprises. If we say Tuesday, we mean Tuesday morning.",
  },
  {
    n: "03",
    title: "Scale",
    quote: "The same crew that fixes your porch can build your headquarters.",
    body:
      "From residential handyman calls to fifty-thousand-square-foot commercial builds — we scale up without losing the details that made us worth calling.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-[#050505] py-28 md:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
          className="grid gap-6 md:grid-cols-[1fr_1.5fr] md:items-baseline"
        >
          <div className="eyebrow">— Chapter One · Manifesto</div>
          <h2 className="font-oswald text-5xl uppercase leading-[0.9] tracking-tight text-white md:text-7xl lg:text-8xl">
            Three things
            <br />
            <span className="text-white/40">we believe.</span>
          </h2>
        </motion.div>

        <div className="mt-16 space-y-16 md:mt-24 md:space-y-24">
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              data-testid={`manifesto-chapter-${c.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{
                duration: 0.9,
                ease: [0.2, 0.8, 0.2, 1],
                delay: i * 0.1,
              }}
              className="grid gap-8 md:grid-cols-[auto_1fr_1.2fr] md:items-start md:gap-16"
            >
              <div className="font-oswald text-[22vw] leading-[0.8] text-white/90 md:text-[10vw]">
                {c.n}
              </div>

              <div>
                <div className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">
                  Chapter {c.n}
                </div>
                <h3 className="mt-3 font-editorial text-4xl italic text-white md:text-6xl">
                  {c.title}
                </h3>
              </div>

              <div className="md:pt-6">
                <p className="font-editorial text-2xl italic leading-snug text-white/85 md:text-3xl">
                  &ldquo;{c.quote}&rdquo;
                </p>
                <p className="mt-6 max-w-lg text-base leading-relaxed text-white/55">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
